import { useEffect } from 'react';
import { DataStatus } from '@/shared/lib';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { initCreativesAuth, selectCreativesAuthStatus } from './slice';

export function useInitCreativesAuth(): void {
  const dispatch = useAppDispatch();
  const authStatus = useAppSelector(selectCreativesAuthStatus);

  useEffect(() => {
    if (authStatus === DataStatus.idle) {
      dispatch(initCreativesAuth());
    }
  }, [authStatus, dispatch]);
}
